// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__14eZV","actions":"GroupTable_actions__1XpbK","deleteModalFooter":"GroupTable_deleteModalFooter__JQNwG"};